import { ItemsListTextareaEditorState } from '../../typings/itemsListTextareaEditorState';

export function getDefaultItemsListTextareaEditorState(): ItemsListTextareaEditorState {
    return {
        isVisible: false,
        value: '',
        errors: []
    };
}

export function parseInputString(
    inputValue: string,
    separator: string
): string[] {
    return inputValue.split(new RegExp(separator));
}

export function formatValueToInputString(
    value: string[],
    separator: string
): string {
    return value.join(separator);
}
